import React, { ReactNode } from "react";
import styled from "styled-components/macro";

const Layout = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  background-color: white;

  max-width: 240mm;
  min-height: 100vh;

  margin: 0 auto;

  @media only screen and (max-width: 480px) {
    min-height: 100dvh;
    height: 100dvh;

    overflow: auto;
    scroll-snap-type: y mandatory;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  @media only screen and (min-width: 481px) {
  }
`;

export default Layout;
